'use strict';

const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    anchorLink: '.js-anchor-link',
    accordionBtn: '.js-accordion-btn',
}

const handleAnchorLinks = function(e) {
    e.preventDefault();

    var target = $($(this).attr('href'));
    if (target.length) {
        var scrollTo = target.offset().top;
        $('body, html').animate({ scrollTop: scrollTo + 'px' }, 800);
    }
}

const handleAccordionBtn = function() {
    $(this).toggleClass(CLASSES.active);
}

/**
 * Init events
 * @returns {void}
 */
function init() {
    $(SELECTORS.anchorLink).on('click', handleAnchorLinks);
    $(SELECTORS.accordionBtn).on('click', handleAccordionBtn);
}

module.exports = {
    init: init()
};
